import React from "react"
import ServiceLogPresenterTabs from '../../ServiceLogPresenter/ServiceLogPresenterTabs'
import ServiceLogPresenterTabContent from '../../ServiceLogPresenter/ServiceLogPresenterTabContent'
import clsx from 'clsx'

class ProductFolioItemPresenterServiceRequests extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      active_tab: "service-log-general",
    }

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'service_requests',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="service_requests">
        <ServiceLogPresenterTabs {...this.state} embedded={true} onChangeActiveTab={this.onChangeActiveTab} />
        <ServiceLogPresenterTabContent {...this.state}
           read_only={true}
           service_log_notes_path={this.props.service_log_notes_path}
           service_log={this.props.service_log}
           reservation_segment={this.props.reservation_segment}
           date_format={this.props.date_format}
           time_format={this.props.time_format}
         />
      </div>

    )

  }

  onChangeActiveTab(tab, e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      active_tab: tab,
    })
  }
}

export default ProductFolioItemPresenterServiceRequests